import React from 'react';
import { AlertTriangleIcon } from './icons/LucideIcons';

// Shown on the order form's tax line while the shop has no sales tax rate:
// orders charge no tax until an admin sets it in Settings → General.
const SalesTaxNotSetChip = () => (
  <span
    className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-800 [html[data-scheme=dark]:not([data-appearance=fable])_&]:border-warn-fg/40 [html[data-scheme=dark]:not([data-appearance=fable])_&]:bg-warn-bg [html[data-scheme=dark]:not([data-appearance=fable])_&]:text-warn-fg"
    title="No tax is charged until an admin sets the shop's rate in Settings → General."
    data-testid="sales-tax-not-set"
  >
    <AlertTriangleIcon size={12} />
    Sales tax rate not set
  </span>
);

export default SalesTaxNotSetChip;
